import { router } from "@inertiajs/react";
import qs from "qs";
import ProductPropertyFilter from "~/components/products/ProductPropertyFilter.jsx";

export default function ({ filters }) {
  if (import.meta.env.SSR) return null;

  const { product_properties } = filters;
  return (
    <div className="space-y-4">
      {product_properties.map((productPropertyFilter) => {
        const params = new URLSearchParams(document.location.search);
        const key = `filter[properties][${productPropertyFilter.name}]`;
        const values = params.get(key)?.split(",") || [];

        return (
          <ProductPropertyFilter
            key={`filter-${productPropertyFilter.name}`}
            productPropertyFilter={productPropertyFilter}
            title={productPropertyFilter.presentation}
          />
        );
      })}
    </div>
  );
}
